// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Interval__intervalContainer___LK8O_ {
    display: flex;
    flex-direction: row;
    gap: var(--space-2xs);
    align-items: baseline;

    &.Interval__top___f8Vba {
        flex-direction: column;
        justify-content: end;
    }

    & .Interval__caption___1aOzE {
        width: 0;
        min-width: 100%;
        padding-top: var(--space-2xs);
        text-wrap: wrap;
    }
}

.Interval__inputField___qaZrA {
    /* stylelint-disable-next-line selector-class-pattern -- класс Consta */
    &.TextField {
        width: unset;
    }

    /* stylelint-disable-next-line selector-class-pattern -- класс Consta */
    & .TextField-Body {
        width: 7rem;

        & input {
            min-width: 0;
        }
    }
}

.Interval__container___YDBhX {
    width: 100%;
}
`, "",{"version":3,"sources":["webpack://./../GM.Frontend.Library/src/components/Interval/Interval.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,mBAAmB;IACnB,qBAAqB;IACrB,qBAAqB;;IAErB;QACI,sBAAsB;QACtB,oBAAoB;IACxB;;IAEA;QACI,QAAQ;QACR,eAAe;QACf,6BAA6B;QAC7B,eAAe;IACnB;AACJ;;AAEA;IACI,uEAAuE;IACvE;QACI,YAAY;IAChB;;IAEA,uEAAuE;IACvE;QACI,WAAW;;QAEX;YACI,YAAY;QAChB;IACJ;AACJ;;AAEA;IACI,WAAW;AACf","sourcesContent":[".intervalContainer {\n    display: flex;\n    flex-direction: row;\n    gap: var(--space-2xs);\n    align-items: baseline;\n\n    &.top {\n        flex-direction: column;\n        justify-content: end;\n    }\n\n    & .caption {\n        width: 0;\n        min-width: 100%;\n        padding-top: var(--space-2xs);\n        text-wrap: wrap;\n    }\n}\n\n.inputField {\n    /* stylelint-disable-next-line selector-class-pattern -- класс Consta */\n    &:global(.TextField) {\n        width: unset;\n    }\n\n    /* stylelint-disable-next-line selector-class-pattern -- класс Consta */\n    & :global(.TextField-Body) {\n        width: 7rem;\n\n        & input {\n            min-width: 0;\n        }\n    }\n}\n\n.container {\n    width: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"intervalContainer": `Interval__intervalContainer___LK8O_`,
	"top": `Interval__top___f8Vba`,
	"caption": `Interval__caption___1aOzE`,
	"inputField": `Interval__inputField___qaZrA`,
	"container": `Interval__container___YDBhX`
};
export default ___CSS_LOADER_EXPORT___;
